import { useMemo, useState, useEffect } from "react";
import { AppId, FCX, usePlatformContext } from "@datassential/platform-ui-lib";
import Ribbon, { RibbonItem } from "@components/Ribbon/Ribbon";
import { sanitizeUrl } from "@helpers";
import { components } from "@apiSchema";
import dayjs from "dayjs";
import {
    BACKGROUND_TRANSITION_DELAY,
    RIBBON_DEFAULTS
} from "@pages/Home/sections/HomeReportsAndNews/HomeReportsAndNews.helpers";

const HomeNews: FCX<{
    data: components["schemas"]["RecentNewsArticleModel"][];
    setBgSrc: (src: string) => void;
}> = ({
    data: rawData,
    setBgSrc,
}) => {
    const {
        userInfo: {
            reportProDetailsUrl,
            products,
        },
    } = usePlatformContext();
    const [activeItemIndex, setActiveItemIndex] = useState<number | null>(null);
    const [backgroundIndex, setBackgroundIndex] = useState<number | null>(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            setBackgroundIndex(activeItemIndex);
        }, BACKGROUND_TRANSITION_DELAY);

        return () => clearTimeout(timer);
    }, [activeItemIndex]);

    const currentItem = useMemo(
        () => backgroundIndex !== null ? rawData?.[backgroundIndex] ?? null : null,
        [backgroundIndex, rawData]
    );

    useEffect(() => {
        setBgSrc(currentItem?.featuredImage ?? '');
    }, [currentItem, setBgSrc]);

    const reportProProduct = useMemo(
        () => products[AppId.ReportPro],
        [products]
    );

    const data = useMemo(
        (): RibbonItem[] => rawData?.map(i => ({
            id: i.id ?? 0,
            title: i.title ?? '',
            description: dayjs(i.publishedDate ?? '').format('MM/DD/YYYY'),
            url: sanitizeUrl(`${reportProProduct.url}/news/article/${i.id ?? ''}`),
            imageUrl: i.featuredImage ?? '',
        })) ?? [],
        [rawData, reportProDetailsUrl, reportProProduct]
    )

    return (
        <Ribbon
            {...RIBBON_DEFAULTS}
            items={data}
            setActiveTileIndex={setActiveItemIndex}
            isAutoSlideDisabled
            className="appears-right"
            itemVariations={['text-always', 'landscape']}
        />
    );
}

export default HomeNews;